// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"86a04e4d","529":"58dacbb6","922":"de50cc85"}[chunkId] + ".chunk.css";
};